import type { Palette, Theme } from '@mui/material';
import { QuickFiltersVariant } from './config';
import { GOTHAM_DISPLAY } from '../../theme';

const getButtonStyles = (palette: Palette, variant: QuickFiltersVariant) => {
  const baseStyles = {
    color: palette.common.black,
    borderRadius: '8px',
    fontSize: '14px',
    height: '35px',
    minHeight: '35px',
    backgroundColor: palette.neutral.lightest,
    '&:hover': {
      backgroundColor: palette.primary.main,
      color: palette.common.white,
    },
    '&:active': {
      backgroundColor: '#81D6B8',
    },
    '&.Mui-selected': {
      backgroundColor: palette.primary.main,
      color: palette.common.white,
    },
    '&:focus-visible': {
      outline: `2px solid ${palette.blues.light}`,
    },
  };

  const blueVariantStyles = {
    fontWeight: 500,
    fontFamily: GOTHAM_DISPLAY,
    textTransform: 'capitalize' as const,
    '&:hover': {
      '@media (hover: hover)': {
        backgroundColor: palette.blues.extraLight,
        color: palette.common.black,
      },
    },
    '&:active': {
      backgroundColor: palette.blues.lightest,
    },
    '&.Mui-selected': {
      backgroundColor: palette.blues.extraLight,
      color: palette.common.black,
    },
  };

  return { ...baseStyles, ...(variant === QuickFiltersVariant.Blue && { ...blueVariantStyles }) };
};

export const getThemeOverrides = (theme: Theme, variant: QuickFiltersVariant) => {
  const buttonStyles = getButtonStyles(theme.palette, variant);
  return {
    components: {
      MuiButton: {
        styleOverrides: {
          outlinedSecondary: {
            ...buttonStyles,
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            maxHeight: '3.5rem',
            overflowY: 'hidden',
            maxWidth: '100%',
            [theme.breakpoints.up('lg')]: {
              maxWidth: '80%',
            },
          },
          flexContainer: {
            gap: 8,
            flexWrap: 'wrap',
            justifyContent: 'center',
            [theme.breakpoints.down('md')]: {
              flexWrap: 'nowrap',
            },
          },
          indicator: {
            display: 'none',
          },
          scroller: {
            padding: '4px',
            overflowY: 'hidden',
            position: 'relative',
            scrollBehavior: 'smooth',
          },
        },
      },
      MuiTab: {
        defaultProps: {
          disableRipple: true,
          disableFocusRipple: true,
          disableTouchRipple: true,
        },
        styleOverrides: {
          root: {
            ...buttonStyles,
          },
        },
      },
    },
  } as const;
};
